import React from 'react';
import { Dialog, DialogContent, DialogTitle, Box, IconButton, Zoom, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '16px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    },
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
    color: '#ffffff',
    padding: '20px 24px',
    '& h3': {
        margin: 0,
        fontWeight: 700,
        fontSize: '1.25rem',
        fontFamily: "'DM Sans', sans-serif",
    },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: '24px !important',
    paddingTop: '28px !important',
    background: '#f8f9fa',
    color: '#000000',
    '& > *:first-child': {
        marginTop: '0 !important',
    },
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'linear-gradient(180deg, #1a73e8 0%, #00bfa5 100%)',
        borderRadius: '10px',
        '&:hover': {
            background: 'linear-gradient(180deg, #1557b0 0%, #009688 100%)',
        },
    },
}));

export default function CustomShowModal(props) {

    const { open, handleClose, maxWidth = "sm", title = 'Stores', description="" } = props;

    return (
        <StyledDialog
            open={open}
            onClose={handleClose}
            scroll='paper'
            fullWidth
            TransitionComponent={Transition}
            maxWidth={maxWidth}
            aria-labelledby="customized-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <StyledDialogTitle id="customized-dialog-title">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <h3>{title}</h3>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            color: '#ffffff',
                            '&:hover': {
                                background: 'rgba(255, 255, 255, 0.1)',
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                {description && (
                    <Typography sx={{ fontSize: '0.875rem', color: 'rgba(255, 255, 255, 0.9)', mt: 1 }}>
                        {description}
                    </Typography>
                )}
            </StyledDialogTitle>
            <StyledDialogContent>
                {props.children}
            </StyledDialogContent>
        </StyledDialog>
    );
}
